import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CLAIM_TYPES } from "@/data/content";

export const ClaimTypes = () => (
  <section id="claims" className="py-24 sm:py-32" data-testid="claim-types">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.22em] font-bold text-forest mb-4">What we recover</p>
          <h2 className="text-4xl sm:text-5xl font-extrabold tracking-tighter text-ink max-w-xl leading-[1.05]">
            Every claim, contested with the same rigor.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-zinc-500 max-w-sm">Individuals and businesses across six lines of insurance — from a hospital denial to a marine cargo loss.</p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        {CLAIM_TYPES.map((c, i) => (
          <Reveal key={c.key} delay={(i % 2) * 0.1} className={c.span}>
            <motion.a href="#contact" whileHover="hover"
              className="group relative block rounded-3xl overflow-hidden h-72 sm:h-80 grain"
              data-testid={`claim-card-${c.key}`}>
              <motion.img src={c.image} alt={c.title}
                variants={{ hover: { scale: 1.08 } }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                className="absolute inset-0 h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/50 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-7 text-white">
                <div className="flex items-start justify-between">
                  <h3 className="text-2xl sm:text-3xl font-bold tracking-tight">{c.title}</h3>
                  <span className="h-10 w-10 rounded-full bg-white/15 backdrop-blur flex items-center justify-center group-hover:bg-forest transition-colors">
                    <ArrowUpRight size={18} />
                  </span>
                </div>
                <p className="mt-2 text-sm text-zinc-200 max-w-md">{c.copy}</p>
              </div>
            </motion.a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default ClaimTypes;
